<template lang="pug">
.vip-history-container(
  :class="{ 'ios-app': iOSAPP }"
  v-infinite-scroll="loadMore",
  infinite-scroll-disabled="loading",
  infinite-scroll-distance="10"
  :style="topStyle"
)
  common-header.header(
    v-if="env.isEasyBikeApp"
    title="购买记录",
    color="#242729",
  )
  .body
    .module-item(v-if="history.length > 0" v-for="(item, index) in history" :key="index")
      .left
        .type {{item.goodsName}}
        .date {{item.createTime | time('YYYY/MM/DD')}}
      .right(@click="handlerHistory(item.orderNo)")
        span.top-right
          .price ￥{{item.payPrice}}
          img.img(src="https://m.hellobike.com/resource/helloyun/15979/TwKDWN6Vky.svg")
        .success 购买{{item.statusLabel}}
</template>

<script>
import CommonHeader from '@/components/common-header';
import { env } from '@hb/NBridge/lib/h5';
import { InfiniteScroll } from 'mint-ui';
import { getTokenAndKey } from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { searchUserVipOrder, queryOrderDetail } from '../../api/vip';

export default {
  components: {
    CommonHeader,
  },
  directives: {
    InfiniteScroll,
  },
  data() {
    return {
      iOSAPP: env.isIOS && env.isEasyBikeApp,
      history: [],
      lastRecordId: '',
      loading: false,
      env,
      topStyle: '',
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.pageView({
      pageId: 'platform_PurchaseRecordsList',
      categoryId: 'platform',
      businessInfo: {},
    });
    next();
  },
  mounted() {
    this.loadMore();
    if (!env.isEasyBikeApp) {
      this.topStyle = 'padding-Top: 0';
    }
  },
  methods: {
    async loadMore() {
      await this.getSearchUserVipOrder();
    },
    async handlerHistory(orderNo) {
      if (typeof orderNo !== 'string') {
        return;
      }
      UBT.clickButton({
        pageId: 'platform_PurchaseRecordsList',
        buttonName: 'platform_PurchaseRecordsClick',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();
      await queryOrderDetail({ token, orderNo })
        .then((v) => {
          if (v && v.data) {
            this.$router.push({
              path: '/vip/history-detail',
              query: {
                item: {
                  ...v.data,
                },
              },
            });
          }
        });
    },
    async getSearchUserVipOrder() {
      this.loading = true;
      const { token } = await getTokenAndKey();
      const toPost = {
        token,
      };
      if (this.lastRecordId) {
        toPost.lastRecordId = this.lastRecordId;
      }
      searchUserVipOrder(toPost)
        .then((v) => {
          if (v && v.data) {
            const { hasMore, pageData } = v.data;
            this.loading = !hasMore;
            if (pageData) {
              if (pageData.length > 0) {
                this.lastRecordId = pageData[pageData.length - 1].guid;
              }
            }
            this.history = this.history.concat(pageData);
          }
        })
        .catch(() => {
          this.loading = true;
        });
    },
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_PurchaseRecordsList',
      categoryId: 'platform',
      businessInfo: {},
    });
    next();
  },
};
</script>

<style lang="less" scoped>
.fontstyle(@lh: 0.22rem, @fs: 0.16rem, @fw: 500, @co: #242729) {
  line-height: @lh;
  font-size: @fs;
  font-weight: @fw;
  color: @co;
}

.vip-history-container {
  height: 100vh;
  padding-top: 0.9rem;

  .ios-app {
    padding-top: 0.44rem;
  }

  .body {
    display: flex;
    flex-direction: column;
    padding: 0.16rem 0.12rem 0;
    background: #f7f9fa;
    min-height: 86.3vh;
  }

  .back {
    width: 0.24rem;
    height: 0.24rem;
  }

  .module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 0.16rem 0.19rem 0.16rem 0.16rem;
    border-radius: 0.09rem;
    box-shadow: 0 0.01rem 0.04rem 0 rgba(0, 0, 0, 0.04);
    margin-bottom: 0.08rem;

    .left,
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .date,
      .success {
        .fontstyle(0.17rem, 0.12rem, 400, #879099);
      }

      .success {
        margin-top: 0.05rem;
      }
    }

    .left {
      .type {
        margin-bottom: 0.05rem;
        .fontstyle();
      }
    }

    .right {
      align-items: flex-end;

      .top-right {
        display: flex;
        justify-content: center;
        align-items: center;

        .price {
          position: relative;
          .fontstyle();

          margin-right: 0.02rem;
        }

        .img {
          width: 0.12rem;
          height: 0.12rem;
        }
      }
    }
  }
}
</style>
